import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { COLORS } from '../../utils';
const leftIcon = ({ className, hexFill: fill, viewBox, onClick, }) => {
    const hexFill = fill || COLORS.midnight;
    return (_jsxs("svg", { onClick: onClick, className: className || '', width: "16px", height: "16px", viewBox: viewBox ? viewBox.join(' ') : '0 0 16 16', xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", children: [_jsx("rect", { width: "16", height: "16", fill: "none" }), _jsx("rect", { x: "5", y: "8", width: "6", height: "1", fill: hexFill })] }));
};
export default leftIcon;
